import r from "../../managers/braze-instance.js";
import { destroyContentCardsHtml as nn } from "../../common/content-cards-display.js";
export function hideContentCards(n) {
  if (!r.rr()) return;
  var o = document.querySelectorAll(".ab-feed");
  for (var t = 0; t < o.length; t++) (null == n || null != n && o[t].parentNode === n) && nn(o[t]);
}